import React from "react";
import PropTypes from "prop-types";
import { formatOfferPrice } from "common/utils/subscriptionCopyHelpers";
import { TERMS_OF_SERVICE_URL } from "common/constants/Constants";
import styles from "./styles.module.scss";

const OfferDetails = ({
    pricing,
    startDate
}) => {
    const { discountPeriod } = pricing;

    return (
        <div className={ styles.confirmBox }>
            <div className={ styles.confirmBoxText }>Your new plan:</div>
            <div className={ styles.confirmBoxBillingPeriod }>{ discountPeriod.toLowerCase() === "month" ? "Monthly" : "Annual" }</div>
            <div className={ styles.confirmBoxRenewInfo }> { formatOfferPrice(pricing) }, renews on { startDate }.
            </div>
            <div className={ styles.confirmBoxDisclaimer }>
                Cancel anytime. No Refunds.{ " " }
                <a href={ TERMS_OF_SERVICE_URL } target="_blank" className={ styles.confirmBoxDisclaimerLink }>
                    Terms&nbsp;&amp;&nbsp;Conditions
                </a>.
            </div>
        </div>
    );
};

OfferDetails.propTypes = {
    pricing: PropTypes.object.isRequired,
    startDate: PropTypes.string.isRequired
};

export default OfferDetails;
